import borders from './src/borders'
import colors from './src/colors'
import fonts from './src/fonts'
import GlobalStyles from './src/global'
import layout from './src/layout'

export { GlobalStyles, borders, colors, fonts, layout }
